import Cards from "./Cards/Cards.jsx";
import Activity from "./Graph/Activity.jsx";
import HeaderBar from "./HeaderBar/HeaderBar.jsx";
import TableLayout from "./TableLayout/TableLayout.jsx";

function VendorDashboard() {
  return (
    <>
      <div style={{ textAlign: "center", marginTop: "10px" }}></div>
      <Cards />
      <Activity/>
      <div>
        <TableLayout />
      </div>
    </>
  );
}

export default VendorDashboard;
